import script from "./support-modal-content.vue?vue&type=script&lang=ts&setup=true"
export * from "./support-modal-content.vue?vue&type=script&lang=ts&setup=true"

import "./support-modal-content.vue?vue&type=style&index=0&id=14efaaf6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14efaaf6"]])

export default __exports__